import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import store from './store'

import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
// import { Provider } from 'react-redux';

ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
    {/* <Provider store={store}> */}
      <App />
    {/* </Provider> */}
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById("root")
);
reportWebVitals();
